import { Component, inject } from '@angular/core';
import { SegmentedButtonComponent } from '../../../shared/components/segmented-button/segmented-button.component';
import { ISegmentedButtonOption } from '../../../shared/components/segmented-button/segmented-button.interface';
import { TItemScope, TItemView } from '../items-filter-card/items-filter-card.interface';
import { ItemsFilterCardService } from '../items-filter-card/items-filter-card.service';
import { ItemsScopePreferenceService } from '../items-scope-preference.service';
import { ItemsViewPreferenceService } from '../items-view-preference.service';

@Component({
  imports: [SegmentedButtonComponent],
  selector: 'app-items-view-controls',
  templateUrl: './items-view-controls.component.html',
})
export class ItemsViewControlsComponent {
  public readonly itemScopeOptions: ISegmentedButtonOption<TItemScope>[] = [
    { icon: 'account_tree', labelKey: 'page.items.button.familyItems', value: 'family' },
    { icon: 'grid_view', labelKey: 'page.items.button.selfItems', value: 'self' },
    { icon: 'arrow_upward', labelKey: 'page.items.escalation.escalated', value: 'escalated' },
  ];

  public readonly itemViewOptions: ISegmentedButtonOption<TItemView>[] = [
    { icon: 'view_list', labelKey: 'field.list', value: 'list' },
    { icon: 'view_column', labelKey: 'field.kanban', value: 'kanban' },
    { icon: 'calendar_month', labelKey: 'field.kamishibai', value: 'kamishibai' },
  ];

  private readonly itemsFilterCardService = inject(ItemsFilterCardService);
  private readonly itemsScopePreference = inject(ItemsScopePreferenceService);
  private readonly itemsViewPreference = inject(ItemsViewPreferenceService);

  public readonly itemScope = this.itemsFilterCardService.itemScope;
  public readonly itemView = this.itemsViewPreference.itemView;

  public setItemView(itemView: TItemView): void {
    this.itemsViewPreference.setItemView(itemView);
  }

  public setItemScope(itemScope: TItemScope): void {
    this.itemsFilterCardService.itemScope.set(itemScope);
    this.itemsScopePreference.setItemScope(itemScope);
  }
}
